import React, { useRef, useState, useEffect } from 'react';
import { Button, Row, Col, Modal, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { connect } from 'react-redux';
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import BlockUi from 'react-block-ui';
import Toastr from '../utils/toastr';
import useMonitorAPIService from '../../services/monitorapiservice';
import DualListBox from 'react-dual-listbox';

function CorporateGroup(props) {

    const { t } = useTranslation();
    const toastrRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [selected, setSelected] = useState([]);
    const [id, setId] = useState(-1);
    const [name, setName] = useState("");
    const [groups, setGroups] = useState([]);
    const { getSupervisedGroups, setCorporateGroup, getSupervisors } = useMonitorAPIService();
    const [supervisors, setSupervisors] = useState([]);
    const [selectedSupervisors, setSelectedSupervisors] = useState([]);

    useEffect(() => {
        if (props.data != null) {
            setId(props.data.id);
            setSelected(props.data.groups);
            setName(props.data.name);
            setSelectedSupervisors(props.data.supervisors);
        } else{
            setId(-1);
            setSelected([]);
            setName([]);
            setSelectedSupervisors([]);
        }

    }, [props.data]);

    const onShow = e => {
        setLoading(true);
        getSupervisedGroups(props.token, (res) => {
            if (res.data != null && res.data.length > 0) {
                let grps = res.data.map(x => { return { label: x.groupName, value: x.groupId } });
                setGroups(grps);
            }

            getSupervisors(props.token, (sRes) => {
                let supervisors = sRes.data.map(x => { return { label: x.name, value: x.id } });
                supervisors = supervisors.filter(x => x.value !== parseInt(props.id));
                setSupervisors(supervisors)
                setLoading(false);
            });

        });
    }

    const setCrpGrp = e => {
        setLoading(true);
        setCorporateGroup(props.token, { id: id, name: name, groups: selected, tenant: window.location.host.split(".")[0], supervisors: selectedSupervisors }, res => {
            props.toggleModal();
            setLoading(false);
        });
    }

    return (<>
        <Modal rtl={props.rtl} show={props.show} onHide={props.toggleModal} onShow={onShow} size="lg">
            <BlockUi tag="div" blocking={loading} color="#009ef7" message={t("pleasewait")}>
                <Modal.Header>
                    <Modal.Title>
                        <FontAwesomeIcon icon={duotone("user-group")} /> {t(props.edit ? "editcrpgrp" : "newcrpgrp")}
                    </Modal.Title>
                    <OverlayTrigger
                        placement="left"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip style={{ position: "fixed" }}>
                            {t("close")}
                        </Tooltip>}>
                        <Button onClick={props.toggleModal} className='float-end'><FontAwesomeIcon icon={solid('xmark')} /></Button>
                    </OverlayTrigger>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            <Form.Group className="mb-4" controlId="fcUserName">
                                <Form.Control type="text" value={name} onChange={e => setName(e.target.value)} placeholder={t("name")} />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Label >{t("groups")}</Form.Label>
                            <DualListBox
                                options={groups}
                                selected={selected}
                                onChange={(value) => setSelected(value)}
                                icons={{
                                    moveLeft: <FontAwesomeIcon icon={duotone("left")} />,
                                    moveAllLeft: [
                                        <FontAwesomeIcon key={0} icon={duotone("left")} />,
                                        <FontAwesomeIcon key={1} icon={duotone("left")} />,
                                    ],
                                    moveRight: <FontAwesomeIcon icon={duotone("right")} />,
                                    moveAllRight: [
                                        <FontAwesomeIcon key={0} icon={duotone("right")} />,
                                        <FontAwesomeIcon key={1} icon={duotone("right")} />,
                                    ]
                                }}
                            /></Col>
                    </Row>
                    <br />
                    <Row>
                        <Col>
                            <Form.Label >{t("supervisors")}</Form.Label>
                            <DualListBox
                                options={supervisors}
                                selected={selectedSupervisors}
                                onChange={(value) => setSelectedSupervisors(value)}
                                icons={{
                                    moveLeft: <FontAwesomeIcon icon={duotone("left")} />,
                                    moveAllLeft: [
                                        <FontAwesomeIcon key={0} icon={duotone("left")} />,
                                        <FontAwesomeIcon key={1} icon={duotone("left")} />,
                                    ],
                                    moveRight: <FontAwesomeIcon icon={duotone("right")} />,
                                    moveAllRight: [
                                        <FontAwesomeIcon key={0} icon={duotone("right")} />,
                                        <FontAwesomeIcon key={1} icon={duotone("right")} />,
                                    ]
                                }}
                            /></Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={setCrpGrp}>
                        <FontAwesomeIcon icon={duotone("paper-plane-top")} /> {t("send")}
                    </Button>
                </Modal.Footer>
            </BlockUi>
        </Modal>
        <Toastr ref={toastrRef} />
    </>)
}

const mapStateToProps = (state) => {
    return {
        id: state.supervisor.id,
        token: state.supervisor.token,
        rtl: state.parameters.rtl
    };
};

export default connect(mapStateToProps, {})(CorporateGroup);